/**
 * Shared constants for SOAP summary widgets
 */

/**
 * Fixed width in pixels for the date column in right-rail summary widgets.
 * Ensures consistent alignment across Problems, Prescriptions, and Labs widgets.
 */
export const RIGHT_RAIL_DATE_COL_PX = 120
